import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { getQueryObj } from './url';

// 根据url获取当前的语言
export const getCurrentLanguage = () => {
  const isSearchLange = window.location.search.includes('lang');
  if (isSearchLange) {
    const { lang } = getQueryObj();
    // 这种情况判断region和lang，组织出默认lang
    return lang === 'zh-CN' ? 'zh-CN' : 'en';
  }
  // 都找不到时候依据部署环境国内 zh-CN   国外 en
  return 'en';
};

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: getCurrentLanguage(),
    fallbackLng: 'en',

    ns: ['translation'],
    defaultNS: 'translation',

    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/webMeet/locales/{#lng#}/{#ns#}.json`,
    },

    debug: false,

    interpolation: {
      escapeValue: false,
      prefix: '{#',
      suffix: '#}',
    },
  });
